import React, { useState, useEffect } from 'react';
import { Container, Dialog, DialogContent, DialogTitle, DialogActions, TextField, Typography, Button, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Box } from '@mui/material';
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, PEDIDOSLISTS, USERACTUALIZAR, PEDIDOSDETALLESVER } from '../services/apiConfig';
import { DataGrid } from '@mui/x-data-grid';
import Cargando from './utils/Cargando.jsx';
import axios from 'axios';
import { format, parse } from 'date-fns';
import esLocale from 'date-fns/locale/es';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerStyles.css';
import * as XLSX from 'xlsx';
import { SaveAlt } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { isAuthenticated } from '../services/api.js';
function PedidosList() {

  useEffect(() => {

   /* const autenticado = isAuthenticated("PedidosList");
    if (autenticado===false) {
      navigate("/login");
    }
*/
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    fetchPedidos(formattedDate, formattedDate);
    // Llamada a la función fetchPedidos con las fechas startDate y endDate
      fetchPedidos(formattedDate, formattedDate);
  }, []); // El segundo argumento [] asegura que esta solicitud se realice solo una vez al montar el componente


 const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const sucursalid = userData?.sucursalid;

  const sucursalnombre =  userData?.sucursalnombre;
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  //ver pedido
  const [verIDPedido, setVerIDPedido] = useState('');
  const [verImporteCupon, setImporteCupon] = useState('');
  const [verFechaPedido, setVerFechaPedido] = useState('');
  const [verHoraPedido, setVerHoraPedido] = useState('');
  const [verNombrePedido, setVerNombrePedido] = useState('');
  const [verDireccionPedido, setVerDireccionPedido] = useState('');
  const [total, setTotal] = useState(0);
  const [orderDetails, setOrderDetails] = useState([]);
  const columns = [
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 75,
      renderCell: (params) => (
        <div>
          <Button onClick={() => handleVer(params.row)}>Ver</Button>
        </div>
      ),},
    { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'fecha', 
      headerName: 'Fecha', 
      width: 155,
      valueFormatter: (params) => {  
        const fecha = new Date(params.value);
        const formattedDate = fecha.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });
        return formattedDate;
      }
    },
    { field: 'nombre', headerName: 'Local', width: 80 },
    { field: 'cliente', headerName: 'Cliente', width: 130 },
    { field: 'direccion', headerName: 'Direccion', width: 300 },
    { field: 'telefono', headerName: 'Telefono', width: 120 },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'abonacon', headerName: 'Abona con', width: 100, hide: true },
    { field: 'comentarios', headerName: 'comentarios', width: 200,  hide: true },
    
    // Agrega más columnas según tus necesidades
  ]; 

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [observacion, setObservacion] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  
    const handleSearchChange = (e) => {
      const term = e.target.value;
      setSearchTerm(term);
  
      const filteredData = users.filter((user) =>
        user.id.toLowerCase().includes(term.toLowerCase())
      );
      setFilteredUsers(filteredData);
    };
 
    const handleVerObservacion = (observacion) => {
      setObservacion(observacion);
      setDialogOpen(true);
    };

  const handleStartDate = (date)=>{
    setStartDate(date);
  };

  const handleEndDate = (date)=>{
    setEndDate(date);
  };


  const exportToExcel = () => {
    const fileName = 'pedidos.xlsx';
    const data = users.map(user => ({
      ID: user.id,
      Fecha: user.fecha,
      Local: user.nombre,
      Cliente: user.cliente,
      Direccion: user.direccion,
      Telefono: user.telefono,
      Mail: user.email,
      Abonacon: user.abonacon,
      Coemtarios: user.comentarios,
      
    }));
  //p.direccion, p.telefono, p.email , p.abonacon, p.comentarios
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cupones');
    XLSX.writeFile(wb, fileName);
  };


  const handleVer = (pedido) => {
    setSelectedUser(pedido);
    setVerIDPedido(pedido.id);
    setImporteCupon(Number(pedido.importecupon).toFixed(2).replace('.', ','));


    setVerFechaPedido(format(parse(pedido.fecha, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd/MM/yyyy'));
    setVerHoraPedido(format(parse(pedido.fecha, 'yyyy-MM-dd HH:mm:ss', new Date()), 'HH:mm'));
    setVerNombrePedido(pedido.cliente);
    setVerDireccionPedido(pedido.direccion);
    axios.get(API_BASE_URL + PEDIDOSDETALLESVER + '?pedido=' + pedido.id)
      .then((response) => {
        if (response && response.data) {
          setOrderDetails(response.data);
  
          const totalPrice = response.data.reduce((accumulator, detail) => {
            return accumulator + detail.precio * detail.cantidad;
          }, 0);
  
          setTotal(totalPrice);
          setIsDialogOpen(true);
        }
      })
      .catch((error) => {
        console.error('Error al cargar los detalles del pedido', error);
      });
  };

  const handleSaveEdit = () => {
    const updatedUserData = {
      id: selectedUser.id,
    };
  
    axios.post(API_BASE_URL + USERACTUALIZAR, updatedUserData)
      .then((response) => {
        console.log('Datos guardados exitosamente:', response.data);
        setIsEditDialogOpen(false); // Cierra el diálogo de edición
      })
      .catch((error) => {
        console.error('Error al guardar los datos:', error);
        // Puedes manejar errores o mostrar un mensaje de error al usuario
      });

      setIsEditDialogOpen(false);
  };

  


  const fetchPedidos = (startDate, endDate) => {
    axios.get(`${API_BASE_URL}${PEDIDOSLISTS}?s=${sucursalid}&startDate=${startDate}&endDate=${endDate}`)
      .then((response) => {
        const userData = response.data;
        setUsers(userData);
        setFilteredUsers(userData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error al cargar los pedidos', error);
        setLoading(false);
      });
  };

  const handleUpdateData = () => {
    setLoading(true); // Activa el estado de carga antes de hacer la solicitud
    console.log("star "+startDate);
    console.log("end "+endDate);

    const fechainicio = startDate;
    const date = new Date(fechainicio);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const fechafin = endDate;
    const datef = new Date(fechafin);

    const yearf = datef.getFullYear();
    const monthf = String(datef.getMonth() + 1).padStart(2, '0');
    const dayf = String(datef.getDate()).padStart(2, '0');

    const formattedStartDate = startDate ? startDate.toISOString() : null;
    const formattedEndDate = endDate ? endDate.toISOString() : null;

    fetchPedidos(formattedStartDate, formattedEndDate);
  };


  return (
    
    <div>
       <Container>
       
      <MenuInicial></MenuInicial>
      
      <div className='miDiv'><h2>Pedidos de la sucursal {sucursalnombre}</h2></div>
         
      <Box display="flex" alignItems="center">


      <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
            <DatePicker
              onChange={handleStartDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Fecha de inicio"
              locale={esLocale}
              selected={startDate  || new Date()}
              maxDate={new Date()}
            />
            <DatePicker
              onChange={handleEndDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Fecha de fin"
              locale={esLocale}
              selected={endDate || new Date()}
              maxDate={new Date()} 
            />
            <Button onClick={handleUpdateData} variant="contained" color="primary">
              Actualizar
            </Button>

        </div>
        </Box>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TextField
          label="Buscar por ID "
          value={searchTerm}
          onChange={handleSearchChange}
        />
            <IconButton onClick={exportToExcel} color="success">
              <SaveAlt />
            </IconButton>
          </div>
      

   
      <div>
      {loading ? (
        // Muestra un mensaje de carga
        <Cargando></Cargando>
      ) : (
        // Muestra la tabla una vez que los datos se han cargado
    
        <DataGrid rows={filteredUsers} columns={columns} />
      )}
    </div>


   
      </Container>
     
      <div style={{ height: '90%', width: '100%' }}>
      <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)}>
        <DialogTitle>Editar Pedido</DialogTitle>
        <DialogContent>
         <div className='miDiv'>
          <TextField
            label="Fecha"
            //value={editedName}
            //onChange={(e) => setEditedName(e.target.value)}
            fullWidth
          />
          </div>
          <div className='miDiv'>
          <TextField
            label="Nombre"
            //value={editedPerfil}
           // onChange={(e) => setEditedPerfil(e.target.value)}
            fullWidth
          />
        </div>

       
         


        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveEdit} color="primary">
            Guardar
          </Button>
          <Button onClick={() => setIsEditDialogOpen(false)} color="primary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      </div>


      <div style={{ height: '90%', width: '100%' }}>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
  <DialogTitle>Pedido {verIDPedido}</DialogTitle>
  <DialogContent>
    <div className='miDivPedido'>
      <TextField label="ID PEDIDO" value={verIDPedido} fullWidth disabled />
    </div>
    <div className='miDivPedido'>
      <TextField label="Fecha Pedido" value={verFechaPedido} fullWidth disabled />
    </div>
    <div className='miDivPedido'>
      <TextField label="Hora Pedido" value={verHoraPedido} fullWidth disabled />
    </div>
    <div className='miDivPedido'>
      <TextField label="Nombre" value={verNombrePedido} fullWidth disabled />
    </div>
    <div className='miDivPedido'>
      <TextField label="Direccion" value={verDireccionPedido} fullWidth disabled />
    </div>
    <Typography variant="h6">Detalles del Pedido</Typography>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Producto</TableCell>
            <TableCell>Cantidad</TableCell>
            <TableCell>Precio Unitario</TableCell>
           
            <TableCell>Subtotal</TableCell>
          </TableRow>
        </TableHead>
  <TableBody>
  {orderDetails.map((detail, index) => {
    const subtotal = (detail.cantidad * detail.precio); // Calcula el subtotal por cada elemento
    return (
      <TableRow key={index}>
        <TableCell>{detail.nombre}</TableCell>
        <TableCell>{detail.cantidad}</TableCell>
        <TableCell>$ {Number(detail.precio).toFixed(2)}</TableCell>
   
        <TableCell>$ {Number(subtotal).toFixed(2)}</TableCell>

        {detail.observaciones && (
                      <Button onClick={() => handleVerObservacion(detail.observaciones)}>
                        Ver
                      </Button>
                    )}
      </TableRow>
    );
  })}
 
 <TableRow>
 <TableCell colSpan={3}>Precio de envío</TableCell>
  <TableCell>
  $ {Number(orderDetails.find(detail => detail.precio_envio !== undefined)?.precio_envio || 0).toFixed(2)}
</TableCell>

</TableRow>
<TableRow>
  <TableCell colSpan={3}>Descuento</TableCell>
  <TableCell>
    $ {(
      verImporteCupon
    )}
  </TableCell>
</TableRow>

<TableRow>
  <TableCell colSpan={3}>Total</TableCell>
  <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
    $ {(
      orderDetails.reduce((total, detail) => total + detail.cantidad * detail.precio, 0) +
      Number(orderDetails.find(detail => detail.precio_envio !== undefined)?.precio_envio || 0)
    ).toFixed(2)}
  </TableCell>
</TableRow>

  
</TableBody>


      </Table>
    </TableContainer>
    <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Observaciones</DialogTitle>
        <DialogContent>{observacion}</DialogContent>
      </Dialog>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setIsDialogOpen(false)} color="primary">
      Cerrar
    </Button>
  </DialogActions>
</Dialog>

      </div>

      </div>

  );
}

export default PedidosList;